import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i5.5
import React from 'react';
import IconWrap from '../../IconWrap';
const SquareHeartOutlined = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.504 2.84l-2.92-1.704a1 1 0 00-1.118.075L8 3.129 5.534 1.21a1 1 0 00-1.118-.075L1.496 2.84A1 1 0 001 3.703v4.421a1 1 0 00.336.748l6 5.333a1 1 0 001.328 0l6-5.333A1 1 0 0015 8.124v-4.42a1 1 0 00-.496-.865zm-3.344.364L13 4.278v3.396l-5.001 4.445L3 7.675V4.277l1.839-1.073L8 5.663l3.16-2.459z",
        clipRule: "evenodd"
    })));
};
SquareHeartOutlined.displayName = 'SquareHeartOutlined';
export default SquareHeartOutlined;
